import {
  createContext,
  useState,
  useMemo,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

interface IAuthContext {
  auth: {
    user?: string;
    accessToken: string;
    roles: string[];
  };
  setAuth: Dispatch<
    SetStateAction<{
      accessToken: string;
      user?: string | undefined;
      roles: string[];
    }>
  >;
}

interface IAuthProviderProps {
  children?: ReactNode;
}

const AuthContext = createContext<IAuthContext | null>(null);

export const AuthProvider = ({ children }: IAuthProviderProps) => {
  const [auth, setAuth] = useState<{
    accessToken: string;
    user?: string;
    roles: string[];
  }>({
    accessToken: '',
    roles: [],
  });
  const authContextProviderValue = useMemo(
    () => ({ auth, setAuth }),
    [auth, setAuth]
  );

  return (
    <AuthContext.Provider value={authContextProviderValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;

// }
